import dayjs from 'dayjs'

export const APPLICATION_STATUS_META = {
  pending: { color: 'processing', text: '待审批' },
  approved: { color: 'success', text: '已批准' },
  rejected: { color: 'error', text: '已拒绝' }
} as const

export function formatApplicationDateTime(value: Date) {
  return dayjs(value).format('YYYY年M月D日 HH:mm')
}
